import {CustomerSubscription} from '../types';
import {
    PlatformPropertyCard,
    PlatformPropertyCardProperty,
} from '@flexinet/ui-components';
import {Link} from 'react-router-dom';
import {Text} from '@mantine/core';

import {useAllowedItems} from '../../../hooks/useAllowedProperties.ts';
import {SubscriptionStatusBadge} from './SubscriptionStatusBadge.tsx';

export const InformationPropertyCard = ({record}: { record: CustomerSubscription }) => {

    const itemCount = Array.isArray(record.items?.items) ? record.items.items.length : 0;
    const customerLabel = record.customer?.name ?? record.customerId;

    const properties = [
        {
            label: 'Subscription ID',
            value: record.id,
            span: 12,
        }, {
            label: 'Status',
            value: <SubscriptionStatusBadge record={record}/>,
            span: 12,
        }, {
            label: 'Customer',
            value: (
                <Link to={`/customers/${record.customerId}`} style={{textDecoration: 'none'}}>
                    <Text c="blue" style={{cursor: 'pointer'}}>{customerLabel}</Text>
                </Link>
            ),
            span: 12,
        }, {
            label: 'Items',
            value: String(itemCount),
            span: 12,
        }] as PlatformPropertyCardProperty[];

    const {filterAllowed} = useAllowedItems();
    const allowedProperties = filterAllowed(properties) as PlatformPropertyCardProperty[];

    return (<PlatformPropertyCard properties={allowedProperties}/>);
};
